import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function MissingPostcode(props) {
    return (
        <span className="statusbar__missing-status">
            <Translation translationKey="catalog-missing-status-speed-load-index-hint" />
            {' '}
            <Translation
                translationKey="catalog-missing-status-missing-postcode"
                className="statusbar__add-information"
                onClick={props.onClick}
            />
        </span>
    );
}

MissingPostcode.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default MissingPostcode;
